import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDelete = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M15 4H20V6H19V19C19 19.55 18.8038 20.0204 18.4121 20.4121C18.0204 20.8038 17.55 21 17 21H7C6.45 21 5.97956 20.8038 5.58789 20.4121C5.19622 20.0204 5 19.55 5 19V6H4V4H9V3H15V4ZM7 19H17V6H7V19ZM11 8V17H9V8H11ZM15 8V17H13V8H15Z" })
});
export default SvgDelete;
